export default class EligiblePricingItem {
  constructor(item) {
    if (!item) {
      this.PricingId = '';
      this.DisplayName = '';
      this.SelectedInList = false;
    } else {
      this.PricingId = item.pricingId;
      this.DisplayName = item.displayName;
      this.SelectedInList = false;
    }
  }

  static displayedInList = 'DisplayName';
}
